import React, { useState, useEffect, useRef } from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, content, size = 'medium', hasCloseButton = true }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (!isOpen) {
      setIsExpanded(false);
      return;
    }

    const handleSelectOpen = () => {
      setIsExpanded(true);
    };

    const handleSelectClose = () => {
      setIsExpanded(false);
    };

    // Listen for react-select menu open/close events
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setIsExpanded(false);
      }
    };

    // Listen for clicks outside select dropdowns to close expanded state
    const handleClickOutside = (e) => {
      if (modalRef.current && modalRef.current.contains(e.target)) {
        // Check if clicked element is part of react-select
        const selectElement = e.target.closest('.css-1pahdxg-control, .css-1hwfws3, [class*="react-select"]');
        if (!selectElement) {
          setIsExpanded(false);
        }
      }
    };

    // Observer to detect when select dropdowns are opened/closed
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          // Check for react-select menu portal
          const selectMenus = document.querySelectorAll('[class*="react-select__menu"], [class*="css-"][class*="menu"]');
          if (selectMenus.length > 0) {
            setIsExpanded(true);
          } else {
            setIsExpanded(false);
          }
        }
      });
    });

    if (modalRef.current) {
      observer.observe(document.body, { 
        childList: true, 
        subtree: true 
      });
    }

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('click', handleClickOutside);

    return () => {
      observer.disconnect();
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div 
        ref={modalRef}
        className={`modal-container modal-${size} ${isExpanded ? 'modal-expanded' : ''}`}
      >
        <div className="modal-header">
          <h2>{title}</h2>
          {hasCloseButton && (
            <button className="modal-close" onClick={onClose}>×</button>
          )}
        </div>
        <div className={`modal-content ${isExpanded ? 'modal-content-expanded' : ''}`}>
          {content}
        </div>
      </div>
    </div>
  );
};

export default Modal; 